import { Edge, Node } from 'reactflow';

export enum FTANodeType {
  TOP_EVENT           = 'top_event',
  INTERMEDIATE_EVENT  = 'intermediate_event',
  BASIC_EVENT         = 'basic_event',
  AND_GATE            = 'and_gate',
  OR_GATE             = 'or_gate',
  UNDEVELOPED_EVENT   = 'undeveloped_event',
  // Extended – IEC 61025 / AIAG-VDA
  XOR_GATE            = 'XOR_GATE',
  INHIBIT_GATE        = 'INHIBIT_GATE',
  PAND_GATE           = 'PAND_GATE',
  CONDITIONING_EVENT  = 'CONDITIONING_EVENT',
  HOUSE_EVENT         = 'HOUSE_EVENT',
  EXTERNAL_EVENT      = 'EXTERNAL_EVENT',
  TRANSFER_IN         = 'TRANSFER_IN',
  TRANSFER_OUT        = 'TRANSFER_OUT',
  BLOCK_FUNCTION      = 'BLOCK_FUNCTION',
  BLOCK_PROCESS       = 'BLOCK_PROCESS',
  BLOCK_DECISION      = 'BLOCK_DECISION',
  BLOCK_CONNECTOR     = 'BLOCK_CONNECTOR',
}

export enum InterfaceType {
  DEFAULT = 'default',
  PHYSICAL = 'physical',   // PH
  MATERIAL = 'material',   // ME
  ENERGY = 'energy',       // ET
  DATA = 'data',           // DX
  HUMAN = 'human'          // HM
}

export interface MitigationPlan {
  action: string;
  resource: string;
  dueDate: string;
  status: 'Open' | 'In Progress' | 'Done';
}

export interface FTANodeData {
  label: string;
  description?: string;
  probability?: number;
  calculatedProbability?: number;
  type: FTANodeType;
  // Visual state
  collapsed?: boolean;
  // Display mode: 'colorful' (vivid) | 'basic' (engineering monochrome)
  displayMode?: 'colorful' | 'basic';
  // Custom Icon for specific industries (e.g. automotive)
  iconType?: 'car' | 'engine' | 'sensor' | 'cpu' | 'warning' | 'battery' | 'plug' | 'network' | 'link' | 'droplet';
  // Action Plan
  mitigation?: MitigationPlan;
}

export interface FTAEdgeData {
  interfaceType?: InterfaceType;
}

// Extended React Flow Node
export type FTANode = Node<FTANodeData>;

export type FTAEdge = Edge<FTAEdgeData>;

export interface TreeStructure {
  nodes: FTANode[];
  edges: FTAEdge[];
}

export interface GenerationRequest {
  topic: string;
  depth?: number;
}
